import { type ButtonProps, IconButton, Button as MuiButton, useTheme } from "@mui/material";

type Props = Pick<ButtonProps, "children" | "onClick" | "variant" | "size"> & {
	isUpperCase?: boolean;
	isFullWidth?: boolean;
	icon?: ButtonProps["startIcon"];
};

const Button = ({ onClick, variant = "outlined", icon, isUpperCase = false, isFullWidth = false, size = "medium", children }: Props): React.ReactNode => {
	const theme = useTheme();

	if (icon !== undefined) {
		return (
			<IconButton size={size} onClick={onClick} sx={{ padding: 0.5 }}>
				{icon}
			</IconButton>
		);
	}

	return (
		<MuiButton
			variant={variant}
			onClick={onClick}
			size={size}
			fullWidth={isFullWidth}
			color="mono"
			sx={{
				boxShadow: variant === "text" ? "none" : theme.shadows[1],
				textTransform: isUpperCase === true ? "uppercase" : "none",
			}}
		>
			{children}
		</MuiButton>
	);
};

export { Button };
